export default __webpack_public_path__ + "static/media/logo-white.c7aa526f.svg";